<div class="h-screen flex flex-col space-y-10 justify-center items-center">
    <ng-lottie [options]="options" class="h-[6.5rem] sm:h-[8rem] md:h-[10rem]"></ng-lottie>
    
    <div class="space-y-2 text-center">
        <p class="font-bold text-xl sm:text-2xl md:text-4xl">O link está inactivo!</p>
        <p class="text-lg sm:text-xl md:text-2xl">Solicita ao comerciante um novo link.</p>
    </div>
    
    <button
        class="px-16 py-2 md:px-20 md:py-3 rounded-full text-lg sm:text-xl md:text-2xl text-white bg-[#2D2D2D]"
        (click)="close()"
    >
        Sair
    </button>
</div>